module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA6ElEQVRYR+2Xaw6DMAyD3UPCIcchQZGKtLG0tVNGmUR/J87X5kFIGHzS4Ph4ANwXWIEXgCUByxkpWoEJwJSA+aj3BZCDm4OduRciB7cL2bFLfUB4ABZ8d+iCOAR3tUop6IZgghtRsQtYAa9GFN9qGypCO4jq05wDiqBiuwM3AcyQEWZsvHRRAC2IaPBqEbLFle3CbUu/QKXI3lnlwSUDFNIRHlj/B+AU3HUp8Kr9siKstdrP25AJwNiEBpEirNhSozgiqPrc83Os3oId2956d7+VbPhSmmf9uLX8jP8ARSP0MVICtGwfgA29B34h4FtEBwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/component/adduser/delete_icon.png
// module id = IiWt
// module chunks = 1